import type { Dispatch, SetStateAction } from "react";
import type { FormType } from "../../components/types";

export const onAddPairingFormExcludeChip = (
  formIndex: number,
  values: string[],
  setForms: Dispatch<SetStateAction<FormType[]>>,
) => {
  setForms(state => {
    const copy: FormType[] = [...state];
    copy[formIndex].excludes = values;
    return copy;
  });
};
